import {IPaymentForm, ITaxForm} from '../../../../../interfaces/forms';

export const readFile = async (proof: IPaymentForm | ITaxForm): Promise<boolean> => {
  if (proof.file && proof.file.uri && proof.file.content == null) {
    try {
    } catch {
      return false;
    }
  }
  return true;
};
